export const selectCampaignState = (state) => state?.dashboardReducer?.campaigns || {};

export const selectCampaignConfig = (state) => selectCampaignState(state).config || null;

export const selectCampaignList = (state) =>
  selectCampaignState(state).list || { count: 0, next: null, previous: null, data: [] };

export const selectCampaignById = (state, campaignId) => {
  const detail = selectCampaignState(state).detail;
  if (detail?.id === campaignId) return detail;
  return selectCampaignList(state)?.data?.find((item) => item?.id === campaignId) || null;
};

export const selectCampaignStats = (state) => selectCampaignState(state).stats || null;

export const selectCampaignHistory = (state) =>
  selectCampaignState(state).history || { count: 0, next: null, previous: null, data: [] };

export const selectCampaignFilters = (state) =>
  selectCampaignState(state).filters || {
    state: "",
    campaign_type: "",
    is_enabled: "",
    country: "",
    search: "",
  };

export const selectCampaignUIFlags = (state) => {
  const campaignState = selectCampaignState(state);
  return {
    configLoading: campaignState.configLoading,
    listLoading: campaignState.listLoading,
    detailLoading: campaignState.detailLoading,
    saveLoading: campaignState.saveLoading,
    actionLoading: campaignState.actionLoading,
    statsLoading: campaignState.statsLoading,
    historyLoading: campaignState.historyLoading,
    formErrors: campaignState.formErrors,
    error: campaignState.error,
    toast: campaignState.toast,
    pagination: campaignState.pagination,
    historyPagination: campaignState.historyPagination,
  };
};
